/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{margin-bottom:4px}.logo[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;text-decoration:none;font-size:24px;font-weight:600;outline:0;cursor:default;height:50px}.logo-icon[_ngcontent-%COMP%]{margin-left:6px;width:372px}"];
export { styles as styles };
